module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tuneMic":"Настройте микрофон","helloMyNameIs":"Если индикатор находится в зелёной зоне, значит микрофон работает нормально."}}')
  delete Component.options._Ctor
}
